<template>
  <!-- view-design version4.3.2 -->
  <div class="layout" :style="{width:portWidth}">
    <!---->
    <Layout>
      <Affix>
        <Header class="head">
          <Row :gutter="16" style="margin:0;"
            ><!---->
            <Col :xs="5" :sm="5" :md="5" :lg="5">
              <div class="header__logo">
                <img
                  height="50%"
                  src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/yueqiaoLogo_horiz5.png"
                />
                <!-- <div class="header_name">
                    <span>广州粤桥工程咨询有限公司</span>
                    <span>GUANGZHOU YUEQIAO ENGINEERING CONSULTING Co., LTD</span>
                  </div> -->
              </div>
            </Col>
            <!-- <Col :xs="2" :sm="2" :md="2" :lg="2">
                <span style="opacity:0;">1</span>
              </Col> -->
            <Col :xs="15" :sm="15" :md="15" :lg="15">
              <Menu
                mode="horizontal"
                theme="light"
                :active-name="selectedNav"
                @on-select="handleLinkTo"
              >
                <div class="layout-nav">
                  <MenuItem
                    :name="item.key"
                    v-for="item in navList"
                    :key="item.key"
                  >
                    {{ item.title }}
                  </MenuItem>
                </div>
              </Menu>
            </Col>
            <Col
              :offset="2"
              :xs="2"
              :sm="2"
              :md="2"
              :lg="2"
              v-if="selectedNav == 'new_home'"
              style="padding-right:20px;"
            >
              <div id="anchor">
                <div class="scrollBar">
                  <div class="ball" style="top:0px;"></div>
                </div>
                <div class="anchorLink">
                  <span
                    v-for="item in anchorList"
                    :key="item.key"
                    @click="anchorClick(item.key)"
                    :class="anchorIndex === item.key ? 'activeA' : 'anchorA'"
                    >{{ item.title }}</span
                  >
                </div>
              </div>
            </Col>
          </Row>
        </Header>
      </Affix>
      <Content :style="{ padding: '0px 0px',width:portWidth }">
        <div style="height:100%;">
          <router-view
            class="content"
            @changeProduce="handleLinkTo"
            @back="controlAutoplay"
            @anchorIndex="handleAnchor"
          />
        </div>
        <!-- <BackTop :height="100" :bottom="150">
          <div class="tothetop">
            <Icon type="ios-arrow-up" color="black" size="30"/>
          </div>
        </BackTop>
        <Collapse style="position:fixed;left:20px;bottom:20px;width:150px;">
          <Panel name="1">
              联系我们
              <Form slot="content">
                <FormItem prop="name">
                    <Input type="text" placeholder="请输入姓名">
                        <Icon type="ios-person-outline"></Icon>
                    </Input>
                </FormItem>
                <FormItem prop="phone">
                    <Input type="text" placeholder="请输入联系方式">
                        <Icon type="ios-lock-outline"></Icon>
                    </Input>
                </FormItem>
                <FormItem>
                    <Button type="primary">提交</Button>
                </FormItem>
            </Form>
          </Panel>
        </Collapse> -->
      </Content>
      <!-- 页脚 -->
      <Footer class="footer">
        <div class="fb">
          <div class="footer__nav">
            <div>
              <div class="title">业务介绍</div>
              <div
                class="items"
                @click="handleSelectedProduce('struct_analyse')"
              >
                工程结构仿真
              </div>
              <div class="items" @click="handleSelectedProduce('struct_moni')">
                工程智能监测
              </div>
              <div class="items" @click="handleSelectedProduce('struct_tech')">
                工程数字科技
              </div>
            </div>
            <div>
              <div class="title">项目展示</div>
              <div class="items" @click="handleLinkTo('projectList')">
                查看项目
              </div>
            </div>
            <div class="image-box">
              <div class="image">
                <img
                  src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/qrcode_for_gh.jpg"
                  width="100%"
                  height="100%"
                />
              </div>
              <div class="title">关注粤桥工科微信公众号了解更多</div>
            </div>
            <div>
              <div class="title">友情链接</div>
              <div
                class="items"
                @click="openUrl('https://www.csijri.com/index.html')"
              >
                中新国际联合研究院
              </div>
            </div>
            <div>
              <div class="title">关于我们</div>
              <div class="items" @click="footLinkTo('about_us', 'introduce')">
                公司简介
              </div>
              <div class="items" @click="footLinkTo('about_us', 'progress')">
                发展历程
              </div>
              <div class="items" @click="footLinkTo('about_us', 'contact')">
                联系我们
              </div>
              <div
                class="items"
                @click="openUrl('https://cloud.yueq.com.cn/home')"
              >
                工程监测
              </div>
            </div>
          </div>
          <div class="footer__des">
            <pre>
  公司总部：广州市天河区长福路207号首层s26单元  研发中心：广州市黄埔区中新智慧一街7号a-1栋1008单元  </pre
            >
            <!-- 联系电话：020 - xxxxxxxx -->
            <pre>
                    <span>Copyright © 2020 广州粤桥工程咨询有限公司 版权所有</span>
                  </pre>
            <pre>
                    <span class="beian" @click="openUrl('https://beian.miit.gov.cn')">粤ICP备19155098号-2</span>
                    <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/beian_icon.png" alt style="display:inline-block;width: 0.25rem;height: 00.25rem;" />
                    <span class="beian" @click="openUrl('https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602011654')">粤公网安备44010602011654号</span>
                  </pre>
          </div>
        </div>
      </Footer>
    </Layout>
  </div>
</template>
<script>
export default {
  name: "layout",
  data() {
    return {
      selectedNav: "new_home",
      navList: [
        { key: "new_home", title: "首页" },
        { key: "new_News", title: "最新消息" },
        { key: "newbusiness", title: "业务介绍" },
        { key: "newprojectList", title: "项目展示" },
        { key: "innovation", title: "科研创新" },
        { key: "newabout_us", title: "关于我们" }
        // { key: 'sign', title: '登录|注册' }
      ],
      produceList: ["newstruct_analyse", "newstruct_moni", "newstruct_tech"],
      portWidth: "1920px",
      isInit: true,
      anchorIndex: 1,
      anchorList: [
        {
          title: "最新消息",
          key: 1
        },
        {
          title: "业务介绍",
          key: 2
        },
        {
          title: "业绩成果",
          key: 3
        }
      ],
      rem: 16
    };
  },
  watch: {
    anchorIndex(val) {
      if (val === 1) {
        document.querySelector(".ball").style.top = 0 + "px";
      } else if (val === 2) {
        document.querySelector(".ball").style.top = (this.rem * 0.32) + "px";//
      } else if (val === 3) {
        document.querySelector(".ball").style.top = (this.rem * 0.62) + "px";//
      }
    }
  },
  created() {
    this.calcWidth();
  },
  mounted() {
    window.onresize = () => {
      this.calcWidth();
    };
    this.flexible()
      // console.log('devicePixelRatio')
      // console.log(window.devicePixelRatio)
      // console.log('window.screen.width')
      // console.log(window.screen.width)
      // console.log('document.body.clientWidth')
      // console.log(document.body.clientWidth)
      // console.log('portWidth')
      // console.log(this.portWidth)
  },
  methods: {
    // 切换菜单
    handleLinkTo(name, tab, cs = null) {
      console.log(name)
      if (name === "toPlatform") {
        this.openUrl("https://cloud.yueq.com.cn/home");
        return 0;
      }
      this.isHome = name === "main_home";
      if (parseInt(this.produceList.indexOf(name)) === -1) {
        this.selectedNav = name;
      } else {
        this.selectedNav = "newbusiness";
      }
      if (name === "newprojectList_detail") this.selectedNav = "newprojectList";
      // if(name === 'participants' || name ==='innovation') this.selectedNav = 'innovation'
      // console.log(name)
      if (tab) {
        this.$router.push({
          name: `${name}`,
          params: {
            scroll: tab
          }
        });
      }
      if (cs) {
        this.$router.push({
          name: `${name}`,
          query: {
            id: cs
          }
        });
      } else {
        this.$router.push({
          name: `${name}`
        });
      }
    },
    controlAutoplay(status) {
      this.autoplay = status;
    },
    calcWidth() {
      // console.log(document.body.clientWidth)
      // let width = parseInt(
      //   Math.floor(window.devicePixelRatio * document.body.clientWidth)
      // );
      this.portWidth = document.body.clientWidth + "px";
      // if(width < 1300 && window.devicePixelRatio==1) this.portWidth = 1300 + 'px'
      // if(width > 1920) this.portWidth = 1920 + 'px'
      // console.log('width')
      // console.log(this.portWidth)
      if (this.isInit) {
        setTimeout(() => {
          this.handleLinkTo("new_home");
          this.calcWidth();
        }, 50);
        this.isInit = false;
      }
    },
    anchorClick(index) {
      let offset = [
        0,
        0,
        document.querySelector("#content2").offsetTop,
        document.querySelector("#content3").offsetTop
      ];
        // document.querySelector("#content2").offsetTop / window.devicePixelRatio,
        // document.querySelector("#content3").offsetTop / window.devicePixelRatio
      if (index !== 0) {
        this.anchorIndex = index;
        window.scrollTo({
          top: offset[index],
          behavior: "smooth"
        });
      }
    },
    handleAnchor(index) {
      this.anchorIndex = index;
    },
    flexible() {
      const _this = this
      var docEl = document.documentElement;
      var dpr = window.devicePixelRatio || 1;
      // adjust body font size
      function setBodyFontSize() {
        if (document.body) {
          document.body.style.fontSize = 16 * dpr + "px";
        } else {
          document.addEventListener("DOMContentLoaded", setBodyFontSize);
        }
      }
      setBodyFontSize();

      // set 1rem = viewWidth / 10
      function setRemUnit() {
        var rem = Math.ceil(docEl.clientWidth / 24);
        _this.rem = rem
        console.log(rem)
        docEl.style.fontSize = rem + "px";
      //  document.body.style.width = document.body.clientWidth
      }

      setRemUnit();

      // reset rem unit on page resize
      window.addEventListener("resize", setRemUnit);
      window.addEventListener("pageshow", function(e) {
        if (e.persisted) {
          setRemUnit();
        }
      });

      // detect 0.5px supports
      if (dpr >= 2) {
        var fakeBody = document.createElement("body");
        var testElement = document.createElement("div");
        testElement.style.border = ".5px solid transparent";
        fakeBody.appendChild(testElement);
        docEl.appendChild(fakeBody);
        if (testElement.offsetHeight === 1) {
          docEl.classList.add("hairlines");
        }
        docEl.removeChild(fakeBody);
      }
    }
  }
};
</script>
<style lang="less" scoped>
//standrad: 1rem=80px
.layout {
  // border: 1px solid #d7dde4;
  background: #f5f7f9;
  position: relative;
  // border-radius: 4px;
  // overflow: hidden;
  min-height: 100%;
  // min-width: 1300px;
  // max-width: 1920px;
}
.head {
  z-index: 11;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
}
.header__logo {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 1rem;
  img {
    display: block;
  }
}
#anchor {
  // float: right;
  // width: 100%;
  height: 1rem;
  position: relative;
  z-index: 99;
  .scrollBar {
    // width: 8px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    .ball {
      display: inline-block;
      position: absolute;
      width: 0.1rem;
      height: 0.1rem;
      border-radius: 50%;
      border: 0.025rem solid #2d8cf0;
      background-color: #fff;
      left: 50%;
      transition: all 0.3s;
      transform: translate(-50%, 2px);
    }
  }
  .scrollBar:before {
    content: " ";
    position: relative;
    width: 0.025rem;//2px
    height: 100%;
    display: block;
    background-color: #e8eaec;
    margin: 0 auto;
  }
  .anchorLink {
    // width: 10em;
    span {
      cursor: pointer;
      font-size: 0.2rem;
      display: block;
      width: 1.6rem;
      line-height: 0.4em;
      padding: 0.12rem 0px 0.12rem 0.2rem;
    }
    span:hover {
      color: #2d8cf0;
    }
    .anchorA {
      color: #515a6e;
    }
    .activeA {
      color: #2d8cf0;
    }
  }
}
.content {
  background-color: #fff;
}
.ivu-menu-horizontal.ivu-menu-light:after {
  content: none;
}
.layout-nav {
  margin: 0 auto;
  // position: absolute;
  // top: 0px;
  // right: 20px;
}
.layout .ivu-layout-header {
  background: #fff;
  height: 1rem;
  padding: 0;
}
.layout-topMiddleBottom .ivu-menu-light {
  background: none;
  color: #fff;
}
.ivu-menu {
  display: flex;
}
.ivu-menu-horizontal {
  height: 1rem;
  line-height: 1rem;
}
.ivu-menu-item {
  font-size: 0.25rem;
  padding: 0;
  margin: 0 8px;
  width: 1.2rem;
  text-align: center;
}
/deep/ .ivu-affix {
  z-index: 11;
}
.tothetop {
  display: block;
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  background-color: #fefefe;
  cursor: pointer;
  height: 50px;
}
.footer {
  display: block;
  padding: 0;
  .fb {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #fff;
    background-color: #2e2e30;
    width: 100%;
    height: 100%;
  }
  &__nav {
    width: 70%;
    padding: 0.6rem;//48px
    display: flex;
    justify-content: space-evenly;
    .title {
      margin-bottom: 0.2rem;//16px
      font-size: 0.25rem;//20px
      line-height: 1.5em;
      font-weight: bold;
    }
    .items {
      font-size: 0.2rem;//16px
      line-height: 2.5em;
      cursor: pointer;
    }
    .image-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      .image {
        width: 1.8rem;//144px
        height: 1.8rem;
        padding: 0.125rem;//10px
        background-color: #fff;
        border-radius: 0.4rem;//32px
        margin-bottom: 0.2rem;//16px
      }
    }
  }
  &__des {
    width: 100%;
    height: 1.1rem;//88px
    background-color: #212124;
    padding-top: 0.1rem;//8px
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 0.2rem;//16px
    line-height: 1.5em;
    pre {
      margin: 0;
      display: flex;
      justify-content: center;
      flex-direction: row;
    }
  }
}

/deep/ .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
  border-bottom: none;
}
/deep/ .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active::before,
.ivu-menu-item:hover::before {
  content: "";
  display: block;
  height: 0.0625rem;
  background: #2d8cf0;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>
